import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'swodoc-node-textarea',
  templateUrl: 'swodoc-node-textarea.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeTextarea implements OnInit {
  @Input()
  node: any;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  // This is the default input field length for HTML
  public characterLimit = 524288;

  public showCharacterLimit = false;

  ngOnInit() {
    if (this.node && this.node.characterLimit && !isNaN(Number(this.node.characterLimit))) {
      this.characterLimit = Number(this.node.characterLimit);
      this.showCharacterLimit = true;
    }
  }

  get text(): string {
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      return this.node.responses[0].value;
    }

    return '';
  }
  set text(value: string) {
    this.node.responses = this.node.responses || [];
    if (this.node.responses.length === 0) {
      this.node.responses.push({ value });
    } else {
      this.node.responses[0] = { value };
    }
    this.changed.emit(this.node);
  }
}
